import { PaymentproviderTypeShort } from "./paymentprovider-type-short.model";

export const PaymentproviderTypeAmazon = "4";
export const PaymentproviderTypeAmazonId = parseInt(PaymentproviderTypeAmazon);
export const PaymentproviderTypeUeberweisung = "2";
export const PaymentproviderTypeUeberweisungId = parseInt(PaymentproviderTypeUeberweisung);
export const PaymentproviderTypePaypal = "1";
export const PaymentproviderTypePaypalId = parseInt(PaymentproviderTypePaypal);
export const PaymentproviderTypePaypalV2 = "10";
export const PaymentproviderTypePaypalV2Id = parseInt(PaymentproviderTypePaypalV2);
export const PaymentproviderTypeSixpayment = "5";
export const PaymentproviderTypeSixpaymentId = parseInt(PaymentproviderTypeSixpayment); 
export const PaymentproviderTypePaypalApplePay = "14";
export const PaymentproviderTypePaypalApplePayId = parseInt(PaymentproviderTypePaypalApplePay);
export const PaymentproviderTypePaypalGooglePay = "15";
export const PaymentproviderTypePaypalGooglePayId = parseInt(PaymentproviderTypePaypalGooglePay);

export interface PaymentproviderType extends PaymentproviderTypeShort {
    img: string;
    imgheight: number;
}